import React, { useRef, useState } from 'react';
import Cropper from 'react-easy-crop';
import ManageModal from 'shared/components/modals/ManageModal';
import { useTranslation } from 'react-i18next';
import { Storage } from 'aws-amplify';
import { useAlert } from 'react-alert';
import { getError } from 'utils/appHelpers';
import { generateDownload } from 'app/routes/Dashboard/routes/Account/routes/ProfileEdit/components/utils';

const ImageCropper = ({ onClose, onSuccess, imgUrl }) => {
  const alert = useAlert();
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [fetching, setFetching] = useState(false);
  const [minMax] = useState({ min: 1, max: 2, aspect: 1 });
  const croppedAreaPixels = useRef();
  const { t } = useTranslation();

  const onCropChange = crop => {
    setCrop(crop);
  };

  const onZoomChange = zoom => {
    setZoom(zoom);
  };

  const onFormSubmit = async () => {
    try {
      setFetching(true);
      const name = `${Date.now()}_product`;
      const blob = await generateDownload(imgUrl, croppedAreaPixels.current);
      const data = await Storage.put(name, blob, { level: 'private', contentType: 'image/png' });
      const imageUrl = await Storage.get(data.key, { level: 'private' });
      onSuccess && onSuccess(imageUrl);
      onClose();
    } catch (err) {
      alert.error(getError(err));
    } finally {
      setFetching(false);
    }
  };

  const onCropComplete = (croppedArea, croppedAreapx) => {
    croppedAreaPixels.current = croppedAreapx;
  };

  return (
    <ManageModal
      title={t('add_product_photo_title')}
      sumbitButton={t('btn_choose')}
      onCloseModal={onClose}
      onSubmit={onFormSubmit}
      isButtonDisabled={fetching}
      showLoadingButton={true}
      className='large-modal avatar-selection-modal'
    >
      <div className='row pb-5'>
        <div className='crop-container'>
          <Cropper
            image={imgUrl}
            crop={crop}
            zoom={zoom}
            aspect={minMax.aspect}
            showGrid={false}
            onCropChange={onCropChange}
            onCropComplete={onCropComplete}
            onZoomChange={onZoomChange}
          />
        </div>
        <div className='controls mt-10 w-100 px-10 px-md-0'>
          <input
            type='range'
            className='form-control'
            value={zoom}
            min={minMax.min}
            max={minMax.max}
            step={0.01}
            disabled={fetching}
            onChange={e => onZoomChange(e.target.value)}
          />
        </div>
      </div>
    </ManageModal>
  );
};

export default ImageCropper;
